// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2bGYT","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1Glwk"};